import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import CompetitionsTable from './CompetitionsTable';
import CompetitionCard from './CompetitionCard';
import { useContext, useEffect, useState } from 'react';
import CreateCompetitionModal from './CreateCompetitionModal';
import EmptyState from '../../components/EmptyState';
import Loading from '../../components/Loading';
import {
  getCreatedCompetitions,
  cancelCompetition,
} from '../../api/Competitions';
import { UserContext } from '../../App';
import CardContainer from '../../components/CardContainer';
import CustomToast from '../../components/CustomToast';
import CancelCompetitionModal from './CancelCompetitionModal';

function Competitions() {
  const [competitions, setCompetitions] = useState([]);
  const [filteredCompetitions, setFilteredCompetitions] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [
    selectedCompetitionForCancellation,
    setSelectedCompetitionForCancellation,
  ] = useState('');
  const [loadingCancellation, setLoadingCancellation] = useState(false);
  const [toastProps, setToastProps] = useState({
    show: false,
  });

  const userContext = useContext(UserContext);

  useEffect(() => {
    async function fetchCompetitions() {
      const result = await getCreatedCompetitions();
      if (result) {
        setCompetitions(result);
        setFilteredCompetitions(result);
        setLoading(false);
      }
    }

    fetchCompetitions();
  }, [userContext]);

  const filterCompetitions = (value) => {
    const allCompetitions = competitions;
    const filtered = allCompetitions.filter((c) =>
      c.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCompetitions(filtered);
  };

  const onCancelCompetition = async (competitionId) => {
    setLoadingCancellation(true);
    const result = await cancelCompetition(competitionId);

    if (result.statusCode === 200) {
      setShowCancelModal(false);
      setToastProps({
        show: true,
        type: 'success',
        title: 'Tävling inställd',
        body: 'Tävlingen är nu inställd.',
      });

      const updatedCompetitions = competitions.map((c) => {
        if (c.id === competitionId) {
          return { ...c, status: 'Inställd' };
        } else {
          return c;
        }
      });

      const updatedFilteredCompetitions = filteredCompetitions.map((c) => {
        if (c.id === competitionId) {
          return { ...c, status: 'Inställd' };
        } else {
          return c;
        }
      });

      setCompetitions(updatedCompetitions);
      setFilteredCompetitions(updatedFilteredCompetitions);
    } else {
      setToastProps({
        show: true,
        type: 'danger',
        title: 'Tävling ej inställd',
        body: 'Tävlingen kunde inte ställas in på grund av ett fel.',
      });
    }

    setLoadingCancellation(false);
  };

  const createCompetitionBtn = (
    <Button
      onClick={() => setModalShow(true)}
      variant='primary'
      className='d-flex align-items-center justify-content-center w-100'
    >
      <span className='material-symbols-outlined me-2'>add</span>Skapa tävling
    </Button>
  );

  return (
    <div>
      <Row>
        <Col md={6}>
          <h2 className='mb-3 w-50'>Tävlingar</h2>
          <p className='text-secondary'>
            Klicka på en tävling för att hantera anmälningar, skapa startlista,
            ladda upp resultat och dokument samt hantera fordon och anbud.
          </p>
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col md={4} lg={3} xl={2} className='d-flex justify-content-between'>
          {createCompetitionBtn}
        </Col>
        <Col
          md={{ offset: 4, span: 4 }}
          lg={{ offset: 6, span: 3 }}
          xl={{ offset: 7, span: 3 }}
        >
          <Form.Control
            className='rounded-pill mt-4 mt-md-0'
            placeholder='Sök'
            onChange={(e) => filterCompetitions(e.target.value)}
          />
        </Col>
      </Row>
      {loading ? (
        <div className='d-flex justify-content-center align-items-center mt-5'>
          <Loading size='100px' text='Laddar tävlingar' />
        </div>
      ) : competitions && competitions.length > 0 ? (
        <Row>
          {' '}
          <Col className='d-none d-lg-flex mt-2'>
            {
              <CompetitionsTable
                competitions={filteredCompetitions}
                rowsPerPage={20}
                onCancel={(competitionId) => {
                  setSelectedCompetitionForCancellation(competitionId);
                  setShowCancelModal(true);
                }}
              />
            }
          </Col>
          <Col className='d-flex flex-column gap-3 d-lg-none mt-2'>
            <CardContainer
              cards={filteredCompetitions.map((c, index) => {
                return (
                  <CompetitionCard
                    key={c.name + `-${index}`}
                    competition={c}
                    onCancel={(competitionId) => {
                      setSelectedCompetitionForCancellation(competitionId);
                      setShowCancelModal(true);
                    }}
                  />
                );
              })}
              rowsPerPage={20}
            />
          </Col>
        </Row>
      ) : (
        <EmptyState
          headingText='Inga tävlingar att visa'
          bodyText='Skapa en tävling för att komma igång'
          action={createCompetitionBtn}
        />
      )}

      <CreateCompetitionModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <CancelCompetitionModal
        onCancel={() => onCancelCompetition(selectedCompetitionForCancellation)}
        loadingCancellation={loadingCancellation}
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
      />

      <CustomToast
        show={toastProps?.show}
        body={toastProps?.body}
        title={toastProps?.title}
        type={toastProps?.type}
        onClose={() => setToastProps({ ...toastProps, show: false })}
      />
    </div>
  );
}

export default Competitions;
